import { AlertTriangleIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface TabErrorProps {
  readonly message: string;
  readonly onRetry: () => void;
}

/**
 * A failed tab says so and offers a retry, rather than rendering as empty.
 * "No meals logged" and "we could not ask" are different facts about a user and
 * an operations console must not conflate them.
 *
 * Deliberately not `ErrorState`, which is otherwise the same card: this one sits
 * inside a tabpanel below the screen's own `h2`, so its heading has to be an
 * `h3`. The styling is kept in step with it by hand.
 */
export function TabError({ message, onRetry }: TabErrorProps) {
  return (
    <section
      role="alert"
      className="flex flex-col items-center gap-3 rounded-xl border border-err-fg/25 bg-err-bg/40 px-8 py-12 text-center"
    >
      <AlertTriangleIcon aria-hidden="true" className="size-5 text-err-fg" />
      <h3 className="text-[15px] font-semibold text-foreground">Could not load this tab</h3>
      <p className="max-w-[460px] font-mono text-[13px] leading-relaxed text-muted-foreground">{message}</p>
      <Button variant="outline" onClick={onRetry} className="mt-1">
        Retry request
      </Button>
    </section>
  );
}
